import {create} from 'zustand';

export const useStationFilter = create(() => ({
    term: '',
    mchs: {
        items: [],
        orAnd: 'or'
    },
    areas: []
}));